function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.5 20h-13C3.57 20 2 17.1 2 13.5S3.57 7 5.5 7h3.57l3.3-3.3c.38-.38 1.33-.07 2.12.7.75.8 1.06 1.75.7 2.14l-.5.46h3.77C20.4 7 22 9.9 22 13.5S20.42 20 18.5 20zm0-2s.04 0 .13-.08c.18-.15.4-.4.58-.77.5-.9.8-2.22.8-3.65 0-1.43-.3-2.74-.8-3.65-.16-.36-.4-.62-.55-.77L18.5 9s-.04 0-.13.08c-.18.15-.4.4-.58.77-.5.9-.8 2.22-.8 3.65 0 1.43.3 2.74.8 3.65.16.36.4.62.55.77l.13.08zm-8.95-8h-5c-.1.32-.2.65-.28 1h5c.08-.35.17-.68.28-1zm1.72 6h-7c.08.35.17.68.28 1h7c-.1-.32-.2-.65-.28-1zM15 13H8v1h7v-1zm-3.73-2c.08-.35.17-.68.28-1h4c-.1.32-.2.65-.28 1h-4zm4 5h-2c.08.35.17.68.28 1h2c-.1-.32-.2-.65-.28-1zM4 13h2v1H4v-1zm14.5-1.25c-.3.25-.5.94-.5 1.75 0 .8.2 1.5.5 1.75.3-.25.5-.94.5-1.75 0-.8-.2-1.5-.5-1.75z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgLocationWood = function SvgLocationWood(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationWood;